export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      contact: 'Contact'
    },
    // Home Page
    home: {
      tagline: 'The art of living in Ibiza',
      servicesOverline: 'Our Expertise',
      servicesTitle: 'A Complete Approach to Luxury Living',
      servicesDescription: 'Twenty years of experience. Ibiza expertise. Absolute discretion. We offer a comprehensive suite of services tailored to the needs of discerning clientele.',
      ibizaOverline: 'Our Focus',
      ibizaTitle: 'Exclusively Ibiza',
      ibizaDescription: 'For two decades, we have devoted ourselves to mastering the Ibiza luxury market. From hidden villas in the north to exclusive beachfront estates, we offer unparalleled knowledge of the island\'s most exceptional properties.',
      ibizaDetail: 'Our deep local connections, intimate understanding of the island\'s character, and commitment to discretion make us the trusted choice for discerning clients seeking the finest Ibiza has to offer.',
      ctaTitle: 'Begin Your Journey',
      ctaDescription: 'Discover what makes Atelier the preferred choice of discerning clients worldwide',
      ctaButton: 'Get in Touch'
    },
    // Services
    services: {
      realEstate: {
        title: 'Real Estate Sales',
        description: 'Exclusive access to the finest properties across the Mediterranean and beyond'
      },
      rentals: {
        title: 'Luxury Rentals',
        description: 'Curated villas and estates for the discerning traveler'
      },
      investment: {
        title: 'Investment Advisory',
        description: 'Strategic guidance for high-value property portfolios'
      },
      management: {
        title: 'Property Management',
        description: 'Comprehensive oversight of your Mediterranean holdings'
      },
      development: {
        title: 'Development Projects',
        description: 'Bespoke development opportunities with vetted partners'
      },
      yacht: {
        title: 'Yacht Charters',
        description: 'Private maritime experiences across the Mediterranean'
      },
      villa: {
        title: 'Villa Rentals',
        description: 'Hand-selected properties for exceptional stays'
      },
      aviation: {
        title: 'Private Aviation',
        description: 'Seamless air travel arrangements worldwide'
      },
      events: {
        title: 'Exclusive Events',
        description: 'Curated private events and bespoke experiences in Ibiza'
      }
    },
    // Markets
    markets: {
      mediterranean: {
        name: 'Mediterranean',
        description: 'Primary base in Ibiza'
      },
      dubai: {
        name: 'Dubai',
        description: 'Middle Eastern luxury'
      },
      miami: {
        name: 'Miami',
        description: 'American gateway'
      },
      newYork: {
        name: 'New York',
        description: 'Global financial center'
      }
    },
    // About Page
    about: {
      overline: 'About Atelier',
      title: 'The art of living in Ibiza',
      intro: 'For two decades, Atelier has served as the quiet gateway to Ibiza\'s most exceptional properties and experiences.',
      paragraph1: 'We are not an agency. We are a house of curated access—where the art of living meets uncompromising service. Based in Ibiza, we operate at the heart of the island\'s luxury real estate and lifestyle market.',
      paragraph2: 'Our clients are global. Their needs, singular. We respond with precision, discretion, and a network cultivated over twenty years on this unique island. No transactions below half a million euros. No compromises on quality. No exceptions to confidentiality.',
      paragraph3: 'From secluded Mediterranean villas to private yacht charters around the island, from development partnerships to property portfolios—we facilitate what others cannot access. This is not abundance. This is selection.',
      philosophyOverline: 'Our Philosophy',
      philosophyTitle: 'Discretion as Standard',
      philosophyP1: 'At Atelier, we do not advertise our clients. We do not publish case studies. We do not measure success in volume.',
      philosophyP2: 'What we offer is this: a bespoke approach, built on decades of relationships and market knowledge. Access to properties that never reach public listings. Introductions that cannot be found on a platform. Service so refined it becomes invisible.',
      philosophyP3: 'Most of our work is conducted under non-disclosure agreements. Our reputation is built not on visibility, but on results—and the trust of those who return to us, year after year.',
      philosophyP4: 'We are Atelier. We facilitate the art of living in Ibiza, and wherever beauty, sun, and discernment converge.',
      stat1Label: 'Years of Global Experience',
      stat2Label: 'Minimum Transaction',
      stat3Label: 'Global Markets',
      ctaTitle: 'Experience the Difference',
      ctaDescription: 'Discover how Atelier can serve your real estate and lifestyle needs',
      ctaButton: 'Contact Us'
    },
    // Contact Page
    contact: {
      overline: 'Contact',
      title: 'Begin a Conversation',
      description: 'All inquiries are handled with the utmost discretion',
      companyName: 'Atelier Prime Estates SL',
      companyTagline: 'The art of living in Ibiza',
      addressLabel: 'Address',
      address1: 'Edificio Nueva Ibiza',
      address2: 'Carrer Gregal 8, Local 24',
      address3: '07800 Eivissa, Spain',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      note: 'All communications are confidential. We respond to serious inquiries within 24 hours.',
      formName: 'Name',
      formEmail: 'Email Address',
      formPhone: 'Phone Number',
      formMarket: 'Market of Interest',
      formMarketPlaceholder: 'Select a market',
      formMessage: 'Your Inquiry',
      submitButton: 'Submit Inquiry',
      submitting: 'Sending...',
      legal: 'Atelier Prime Estates SL · CIF B26974915 · Registered in Spain',
      toastTitle: 'Inquiry Received',
      toastDescription: 'Thank you for your interest. We will be in touch shortly.'
    },
    // Footer
    footer: {
      tagline: 'The art of living in Ibiza',
      navigate: 'Navigate',
      services: 'Services',
      contact: 'Contact',
      copyright: 'Atelier Prime Estates SL · CIF B26974915',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    },
    // Privacy Page
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated: December 2025',
      section1Title: '1. Data Controller',
      section1Content: 'Atelier Prime Estates SL|CIF: B26974915|Address: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spain|Email: Office@atelierprimeibiza.com',
      section2Title: '2. Data We Collect',
      section2Intro: 'We collect the following personal data when you use our services:',
      section2Items: 'Contact Information: Name, email address, phone number|Inquiry Details: Property interests, market preferences, messages|Technical Data: IP address, browser type, device information|Cookies: Usage data, preferences, session information',
      section3Title: '3. Legal Basis for Processing (LOPD/GDPR)',
      section3Intro: 'We process your personal data based on:',
      section3Items: 'Consent: When you submit inquiry forms or accept cookies|Contractual Necessity: To provide services you request|Legitimate Interest: To improve our services and communicate relevant opportunities|Legal Obligation: To comply with Spanish and EU legal requirements',
      section4Title: '4. How We Use Your Data',
      section4Intro: 'Your personal information is used to:',
      section4Items: 'Respond to property inquiries and service requests|Provide personalized real estate recommendations|Send updates about properties and services (with your consent)|Improve our website and user experience|Comply with legal and regulatory obligations',
      section5Title: '5. Data Sharing and Disclosure',
      section5Intro: 'We maintain absolute discretion. Your data may only be shared with:',
      section5Items: 'Trusted service providers (email, hosting) under strict confidentiality agreements|Legal authorities when required by Spanish or EU law|Property owners (only with your explicit consent)',
      section5Footer: 'We never sell your personal data to third parties.',
      section6Title: '6. International Data Transfers',
      section6Content: 'Your data is primarily stored within the European Economic Area (EEA). Any transfers outside the EEA are protected by appropriate safeguards in compliance with GDPR Article 46.',
      section7Title: '7. Your Rights Under LOPD/GDPR',
      section7Intro: 'You have the right to:',
      section7Items: 'Access: Request a copy of your personal data|Rectification: Correct inaccurate information|Erasure: Request deletion of your data ("right to be forgotten")|Restriction: Limit how we process your data|Portability: Receive your data in a structured format|Object: Oppose processing based on legitimate interests|Withdraw Consent: Revoke consent at any time',
      section7Footer: 'To exercise these rights, contact us at Office@atelierprimeibiza.com',
      section8Title: '8. Data Retention',
      section8Content: 'We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy or as required by Spanish law. Client inquiry data is typically retained for 3 years unless you request earlier deletion.',
      section9Title: '9. Security Measures',
      section9Content: 'We implement industry-standard security measures including encryption, secure servers, and access controls to protect your personal data from unauthorized access, alteration, or disclosure.',
      section10Title: '10. Cookies',
      section10Content: 'We use cookies to enhance your browsing experience. You can manage cookie preferences through our cookie banner. For details, see our Cookie Policy.',
      section11Title: '11. Children\'s Privacy',
      section11Content: 'Our services are not directed to individuals under 18. We do not knowingly collect data from minors.',
      section12Title: '12. Changes to This Policy',
      section12Content: 'We may update this Privacy Policy periodically. Changes will be posted on this page with an updated revision date.',
      section13Title: '13. Contact & Complaints',
      section13Content: 'For privacy concerns or to file a complaint:|Email: Office@atelierprimeibiza.com|Address: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spain',
      section13Footer: 'You also have the right to lodge a complaint with the Spanish Data Protection Authority (Agencia Española de Protección de Datos - AEPD).'
    },
    // Terms Page
    terms: {
      title: 'Terms of Service',
      lastUpdated: 'Last Updated: December 2025',
      section1Title: '1. Acceptance of Terms',
      section1Content: 'By accessing and using the Atelier Prime Estates SL website ("Website"), you agree to be bound by these Terms of Service. If you do not agree, please discontinue use immediately.',
      section2Title: '2. Company Information',
      section2Content: 'Atelier Prime Estates SL|CIF: B26974915|Registered Address: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spain|Registered in Spain',
      section3Title: '3. Services Provided',
      section3Intro: 'Atelier offers luxury real estate and lifestyle services including:',
      section3Items: 'Real estate sales and rentals|Investment advisory|Property management|Development projects|Luxury lifestyle services (yacht charters, villa rentals, private aviation)',
      section3Footer: 'All services are subject to individual agreements and are not guaranteed through Website usage alone.',
      section4Title: '4. Eligibility',
      section4Content: 'Our services are intended for individuals aged 18 and over. By using this Website, you represent that you meet this age requirement.',
      section5Title: '5. Minimum Transaction Requirements',
      section5Content: 'Atelier specializes in high-value transactions with a minimum threshold of €500,000. We reserve the right to decline inquiries that do not meet our service criteria.',
      section6Title: '6. Confidentiality and Non-Disclosure',
      section6Content: 'All client interactions are conducted with absolute discretion. Property details, client information, and transaction terms are confidential. Most services are provided under non-disclosure agreements (NDAs).',
      section7Title: '7. Intellectual Property',
      section7Content: 'All content on this Website, including text, images, logos, and design, is the property of Atelier Prime Estates SL and protected by Spanish and international copyright laws. Unauthorized use is prohibited.',
      section8Title: '8. Website Use Restrictions',
      section8Intro: 'You agree not to:',
      section8Items: 'Use the Website for unlawful purposes|Attempt to gain unauthorized access to our systems|Interfere with Website functionality|Copy, reproduce, or distribute Website content without permission|Use automated systems to scrape or extract data',
      section9Title: '9. Property Listings and Information',
      section9Content: 'Property information is provided for general reference. Details, availability, and pricing are subject to change without notice. Atelier makes no warranties regarding accuracy or completeness of listing information.',
      section10Title: '10. Third-Party Links',
      section10Content: 'Our Website may contain links to third-party sites. Atelier is not responsible for the content or practices of external websites.',
      section11Title: '11. Limitation of Liability',
      section11Content: 'To the fullest extent permitted by Spanish law, Atelier Prime Estates SL shall not be liable for indirect, incidental, or consequential damages arising from Website use or service provision.',
      section12Title: '12. Disclaimer of Warranties',
      section12Content: 'The Website is provided "as is" without warranties of any kind. Atelier does not guarantee uninterrupted or error-free operation.',
      section13Title: '13. Indemnification',
      section13Content: 'You agree to indemnify Atelier Prime Estates SL from claims arising from your use of the Website or violation of these Terms.',
      section14Title: '14. Governing Law and Jurisdiction',
      section14Content: 'These Terms are governed by Spanish law. Any disputes shall be subject to the exclusive jurisdiction of the courts of Ibiza, Spain.',
      section15Title: '15. Modifications to Terms',
      section15Content: 'Atelier reserves the right to modify these Terms at any time. Continued use of the Website constitutes acceptance of updated Terms.',
      section16Title: '16. Termination',
      section16Content: 'We reserve the right to terminate or suspend access to the Website at our discretion, without notice, for violations of these Terms.',
      section17Title: '17. Severability',
      section17Content: 'If any provision of these Terms is found invalid, the remaining provisions shall continue in full effect.',
      section18Title: '18. Contact Information',
      section18Content: 'For questions regarding these Terms:|Email: Office@atelierprimeibiza.com|Address: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spain'
    }
  },
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      contact: 'Kontakt'
    },
    // Home Page
    home: {
      tagline: 'Die Kunst des Lebens in Ibiza',
      servicesOverline: 'Unsere Expertise',
      servicesTitle: 'Ein umfassender Ansatz für luxuriöses Leben',
      servicesDescription: 'Zwanzig Jahre Erfahrung. Ibiza-Expertise. Absolute Diskretion. Wir bieten eine umfassende Suite von Dienstleistungen für anspruchsvolle Klientel.',
      ibizaOverline: 'Unser Fokus',
      ibizaTitle: 'Ausschließlich Ibiza',
      ibizaDescription: 'Seit zwei Jahrzehnten widmen wir uns der Beherrschung des Ibiza-Luxusmarktes. Von versteckten Villen im Norden bis zu exklusiven Strandimmobilien bieten wir unvergleichliche Kenntnisse der außergewöhnlichsten Immobilien der Insel.',
      ibizaDetail: 'Unsere tiefen lokalen Verbindungen, unser intimes Verständnis des Inselcharakters und unser Engagement für Diskretion machen uns zur vertrauenswürdigen Wahl für anspruchsvolle Kunden, die das Beste suchen, was Ibiza zu bieten hat.',
      ctaTitle: 'Beginnen Sie Ihre Reise',
      ctaDescription: 'Entdecken Sie, was Atelier zur bevorzugten Wahl anspruchsvoller Kunden weltweit macht',
      ctaButton: 'Kontakt aufnehmen'
    },
    services: {
      realEstate: {
        title: 'Immobilienverkauf',
        description: 'Exklusiver Zugang zu den schönsten Immobilien am Mittelmeer und darüber hinaus'
      },
      rentals: {
        title: 'Luxusvermietung',
        description: 'Kuratierte Villen und Anwesen für anspruchsvolle Reisende'
      },
      investment: {
        title: 'Anlageberatung',
        description: 'Strategische Beratung für hochwertige Immobilienportfolios'
      },
      management: {
        title: 'Immobilienverwaltung',
        description: 'Umfassende Betreuung Ihrer mediterranen Immobilien'
      },
      development: {
        title: 'Entwicklungsprojekte',
        description: 'Maßgeschneiderte Entwicklungsmöglichkeiten mit geprüften Partnern'
      },
      yacht: {
        title: 'Yachtcharter',
        description: 'Private maritime Erlebnisse im Mittelmeer'
      },
      villa: {
        title: 'Villenvermietung',
        description: 'Handverlesene Immobilien für außergewöhnliche Aufenthalte'
      },
      aviation: {
        title: 'Privatluftfahrt',
        description: 'Nahtlose Flugreisearrangements weltweit'
      },
      events: {
        title: 'Exklusive Veranstaltungen',
        description: 'Kuratierte private Events und maßgeschneiderte Erlebnisse in Ibiza'
      }
    },
    markets: {
      mediterranean: {
        name: 'Mittelmeer',
        description: 'Hauptsitz in Ibiza'
      },
      dubai: {
        name: 'Dubai',
        description: 'Nahöstlicher Luxus'
      },
      miami: {
        name: 'Miami',
        description: 'Amerikanisches Tor'
      },
      newYork: {
        name: 'New York',
        description: 'Globales Finanzzentrum'
      }
    },
    about: {
      overline: 'Über Atelier',
      title: 'Die Kunst des Lebens in Ibiza',
      intro: 'Seit zwei Jahrzehnten dient Atelier als stilles Tor zu den außergewöhnlichsten Immobilien und Erlebnissen des Mittelmeers.',
      paragraph1: 'Wir sind keine Agentur. Wir sind ein Haus des kuratierten Zugangs – wo die Kunst des Lebens auf kompromisslosen Service trifft. Mit Sitz in Ibiza und Präsenz in Dubai, Miami, New York und darüber hinaus operieren wir an der Schnittstelle von Immobilien, Investitionen und Lifestyle.',
      paragraph2: 'Unsere Kunden sind global. Ihre Bedürfnisse singular. Wir antworten mit Präzision, Diskretion und einem über zwanzig Jahre kultivierten Netzwerk. Keine Transaktionen unter einer halben Million Euro. Keine Kompromisse bei der Qualität. Keine Ausnahmen bei der Vertraulichkeit.',
      paragraph3: 'Von mediterranen Villen bis zu privaten Yachtchartern, von Entwicklungspartnerschaften bis zu Immobilienportfolios – wir ermöglichen, was andere nicht erreichen können. Dies ist nicht Überfluss. Dies ist Selektion.',
      philosophyOverline: 'Unsere Philosophie',
      philosophyTitle: 'Diskretion als Standard',
      philosophyP1: 'Bei Atelier werben wir nicht mit unseren Kunden. Wir veröffentlichen keine Fallstudien. Wir messen Erfolg nicht in Volumen.',
      philosophyP2: 'Was wir bieten ist dies: ein maßgeschneiderter Ansatz, aufgebaut auf jahrzehntelangen Beziehungen und Marktkenntnissen. Zugang zu Immobilien, die nie öffentliche Angebote erreichen. Vermittlungen, die auf keiner Plattform zu finden sind. Service so raffiniert, dass er unsichtbar wird.',
      philosophyP3: 'Die meisten unserer Arbeiten werden unter Geheimhaltungsvereinbarungen durchgeführt. Unser Ruf basiert nicht auf Sichtbarkeit, sondern auf Ergebnissen – und dem Vertrauen derer, die Jahr für Jahr zu uns zurückkehren.',
      philosophyP4: 'Wir sind Atelier. Wir ermöglichen die Kunst des Lebens in Ibiza und überall dort, wo Schönheit, Sonne und Urteilsvermögen zusammentreffen.',
      stat1Label: 'Jahre globale Erfahrung',
      stat2Label: 'Mindest-Transaktion',
      stat3Label: 'Globale Märkte',
      ctaTitle: 'Erleben Sie den Unterschied',
      ctaDescription: 'Entdecken Sie, wie Atelier Ihre Immobilien- und Lifestyle-Bedürfnisse erfüllen kann',
      ctaButton: 'Kontaktieren Sie uns'
    },
    // Contact Page
    contact: {
      overline: 'Kontakt',
      title: 'Beginnen Sie ein Gespräch',
      description: 'Alle Anfragen werden mit größter Diskretion behandelt',
      companyName: 'Atelier Prime Estates SL',
      companyTagline: 'Die Kunst des Lebens in Ibiza',
      addressLabel: 'Adresse',
      address1: 'Edificio Nueva Ibiza',
      address2: 'Carrer Gregal 8, Local 24',
      address3: '07800 Eivissa, Spanien',
      emailLabel: 'E-Mail',
      phoneLabel: 'Telefon',
      note: 'Alle Kommunikationen sind vertraulich. Wir antworten auf seriöse Anfragen innerhalb von 24 Stunden.',
      formName: 'Name',
      formEmail: 'E-Mail-Adresse',
      formPhone: 'Telefonnummer',
      formMarket: 'Interessierter Markt',
      formMarketPlaceholder: 'Wählen Sie einen Markt',
      formMessage: 'Ihre Anfrage',
      submitButton: 'Anfrage senden',
      submitting: 'Wird gesendet...',
      legal: 'Atelier Prime Estates SL · CIF B26974915 · Registriert in Spanien'
    },
    footer: {
      tagline: 'Die Kunst des Lebens in Ibiza',
      navigate: 'Navigation',
      services: 'Dienstleistungen',
      contact: 'Kontakt',
      copyright: 'Atelier Prime Estates SL · CIF B26974915',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen'
    },
    privacy: {
      title: 'Datenschutzerklärung',
      lastUpdated: 'Zuletzt aktualisiert: Dezember 2025',
      section1Title: '1. Verantwortliche Stelle',
      section1Content: 'Atelier Prime Estates SL|CIF: B26974915|Adresse: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spanien|E-Mail: Office@atelierprimeibiza.com',
      section2Title: '2. Erhobene Daten',
      section2Intro: 'Wir erheben folgende personenbezogene Daten bei der Nutzung unserer Dienste:',
      section2Items: 'Kontaktinformationen: Name, E-Mail-Adresse, Telefonnummer|Anfrage-Details: Immobilieninteressen, Marktpräferenzen, Nachrichten|Technische Daten: IP-Adresse, Browsertyp, Geräteinformationen|Cookies: Nutzungsdaten, Präferenzen, Sitzungsinformationen',
      section3Title: '3. Rechtsgrundlage der Verarbeitung (LOPD/DSGVO)',
      section3Intro: 'Wir verarbeiten Ihre personenbezogenen Daten auf Grundlage von:',
      section3Items: 'Einwilligung: Wenn Sie Anfrageformulare absenden oder Cookies akzeptieren|Vertragserfüllung: Zur Erbringung der von Ihnen angeforderten Dienstleistungen|Berechtigtes Interesse: Zur Verbesserung unserer Dienste und Kommunikation relevanter Angebote|Rechtliche Verpflichtung: Zur Einhaltung spanischer und EU-rechtlicher Anforderungen',
      section4Title: '4. Verwendung Ihrer Daten',
      section4Intro: 'Ihre persönlichen Informationen werden verwendet, um:',
      section4Items: 'Auf Immobilienanfragen und Serviceanfragen zu antworten|Personalisierte Immobilienempfehlungen bereitzustellen|Updates über Immobilien und Dienstleistungen zu senden (mit Ihrer Einwilligung)|Unsere Website und Benutzererfahrung zu verbessern|Gesetzliche und regulatorische Verpflichtungen zu erfüllen',
      section5Title: '5. Datenweitergabe und Offenlegung',
      section5Intro: 'Wir wahren absolute Diskretion. Ihre Daten werden nur weitergegeben an:',
      section5Items: 'Vertrauenswürdige Dienstleister (E-Mail, Hosting) unter strengen Vertraulichkeitsvereinbarungen|Rechtsbehörden, wenn nach spanischem oder EU-Recht erforderlich|Immobilieneigentümer (nur mit Ihrer ausdrücklichen Zustimmung)',
      section5Footer: 'Wir verkaufen Ihre persönlichen Daten niemals an Dritte.',
      section6Title: '6. Internationale Datenübertragungen',
      section6Content: 'Ihre Daten werden hauptsächlich im Europäischen Wirtschaftsraum (EWR) gespeichert. Übertragungen außerhalb des EWR sind durch geeignete Garantien gemäß DSGVO Artikel 46 geschützt.',
      section7Title: '7. Ihre Rechte gemäß LOPD/DSGVO',
      section7Intro: 'Sie haben das Recht auf:',
      section7Items: 'Auskunft: Anforderung einer Kopie Ihrer personenbezogenen Daten|Berichtigung: Korrektur unrichtiger Informationen|Löschung: Anforderung der Löschung Ihrer Daten ("Recht auf Vergessenwerden")|Einschränkung: Begrenzung der Verarbeitung Ihrer Daten|Datenübertragbarkeit: Erhalt Ihrer Daten in einem strukturierten Format|Widerspruch: Widerspruch gegen Verarbeitung aufgrund berechtigter Interessen|Widerruf der Einwilligung: Widerruf der Einwilligung jederzeit',
      section7Footer: 'Um diese Rechte auszuüben, kontaktieren Sie uns unter Office@atelierprimeibiza.com',
      section8Title: '8. Datenspeicherung',
      section8Content: 'Wir speichern Ihre personenbezogenen Daten nur so lange, wie es zur Erfüllung der in dieser Richtlinie dargelegten Zwecke oder wie nach spanischem Recht erforderlich ist. Kundenanfragedaten werden in der Regel 3 Jahre lang gespeichert, sofern Sie keine vorzeitige Löschung beantragen.',
      section9Title: '9. Sicherheitsmaßnahmen',
      section9Content: 'Wir implementieren branchenübliche Sicherheitsmaßnahmen einschließlich Verschlüsselung, sichere Server und Zugriffskontrollen, um Ihre personenbezogenen Daten vor unbefugtem Zugriff, Änderung oder Offenlegung zu schützen.',
      section10Title: '10. Cookies',
      section10Content: 'Wir verwenden Cookies, um Ihr Browsing-Erlebnis zu verbessern. Sie können Cookie-Präferenzen über unser Cookie-Banner verwalten. Details finden Sie in unserer Cookie-Richtlinie.',
      section11Title: '11. Datenschutz für Kinder',
      section11Content: 'Unsere Dienste richten sich nicht an Personen unter 18 Jahren. Wir erheben wissentlich keine Daten von Minderjährigen.',
      section12Title: '12. Änderungen dieser Richtlinie',
      section12Content: 'Wir können diese Datenschutzerklärung regelmäßig aktualisieren. Änderungen werden auf dieser Seite mit aktualisiertem Datum veröffentlicht.',
      section13Title: '13. Kontakt & Beschwerden',
      section13Content: 'Bei Datenschutzbedenken oder zur Einreichung einer Beschwerde:|E-Mail: Office@atelierprimeibiza.com|Adresse: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spanien',
      section13Footer: 'Sie haben auch das Recht, eine Beschwerde bei der spanischen Datenschutzbehörde (Agencia Española de Protección de Datos - AEPD) einzureichen.'
    },
    terms: {
      title: 'Nutzungsbedingungen',
      lastUpdated: 'Zuletzt aktualisiert: Dezember 2025',
      section1Title: '1. Annahme der Bedingungen',
      section1Content: 'Durch den Zugriff auf und die Nutzung der Website von Atelier Prime Estates SL ("Website") erklären Sie sich mit diesen Nutzungsbedingungen einverstanden. Wenn Sie nicht einverstanden sind, stellen Sie bitte die Nutzung sofort ein.',
      section2Title: '2. Unternehmensinformationen',
      section2Content: 'Atelier Prime Estates SL|CIF: B26974915|Eingetragene Adresse: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spanien|Registriert in Spanien',
      section3Title: '3. Angebotene Dienstleistungen',
      section3Intro: 'Atelier bietet Luxusimmobilien- und Lifestyle-Dienstleistungen an, darunter:',
      section3Items: 'Immobilienverkauf und -vermietung|Anlageberatung|Immobilienverwaltung|Entwicklungsprojekte|Luxus-Lifestyle-Dienstleistungen (Yachtcharter, Villenvermietung, Privatluftfahrt)',
      section3Footer: 'Alle Dienstleistungen unterliegen individuellen Vereinbarungen und werden nicht allein durch die Nutzung der Website garantiert.',
      section4Title: '4. Berechtigung',
      section4Content: 'Unsere Dienste richten sich an Personen ab 18 Jahren. Durch die Nutzung dieser Website bestätigen Sie, dass Sie diese Altersanforderung erfüllen.',
      section5Title: '5. Mindesttransaktionsanforderungen',
      section5Content: 'Atelier ist auf hochwertige Transaktionen mit einem Mindestwert von 500.000 € spezialisiert. Wir behalten uns das Recht vor, Anfragen abzulehnen, die unsere Servicekriterien nicht erfüllen.',
      section6Title: '6. Vertraulichkeit und Geheimhaltung',
      section6Content: 'Alle Kundenkontakte werden mit absoluter Diskretion behandelt. Immobiliendetails, Kundeninformationen und Transaktionsbedingungen sind vertraulich. Die meisten Dienstleistungen werden unter Geheimhaltungsvereinbarungen (NDAs) erbracht.',
      section7Title: '7. Geistiges Eigentum',
      section7Content: 'Alle Inhalte auf dieser Website, einschließlich Text, Bilder, Logos und Design, sind Eigentum von Atelier Prime Estates SL und durch spanische und internationale Urheberrechtsgesetze geschützt. Unbefugte Nutzung ist untersagt.',
      section8Title: '8. Einschränkungen der Website-Nutzung',
      section8Intro: 'Sie verpflichten sich, nicht:',
      section8Items: 'Die Website für rechtswidrige Zwecke zu nutzen|Unbefugten Zugriff auf unsere Systeme zu erlangen|Die Website-Funktionalität zu beeinträchtigen|Website-Inhalte ohne Genehmigung zu kopieren, zu reproduzieren oder zu verteilen|Automatisierte Systeme zum Scrapen oder Extrahieren von Daten zu verwenden',
      section9Title: '9. Immobilienangebote und Informationen',
      section9Content: 'Immobilieninformationen dienen nur als allgemeine Referenz. Details, Verfügbarkeit und Preise können sich ohne Vorankündigung ändern. Atelier übernimmt keine Gewährleistung hinsichtlich der Genauigkeit oder Vollständigkeit der Angebotsinformationen.',
      section10Title: '10. Links zu Drittanbietern',
      section10Content: 'Unsere Website kann Links zu Websites Dritter enthalten. Atelier ist nicht verantwortlich für den Inhalt oder die Praktiken externer Websites.',
      section11Title: '11. Haftungsbeschränkung',
      section11Content: 'Im weitesten gesetzlich zulässigen Umfang haftet Atelier Prime Estates SL nicht für indirekte, zufällige oder Folgeschäden, die sich aus der Nutzung der Website oder der Erbringung von Dienstleistungen ergeben.',
      section12Title: '12. Gewährleistungsausschluss',
      section12Content: 'Die Website wird "wie besehen" ohne jegliche Gewährleistung bereitgestellt. Atelier garantiert keinen ununterbrochenen oder fehlerfreien Betrieb.',
      section13Title: '13. Freistellung',
      section13Content: 'Sie verpflichten sich, Atelier Prime Estates SL von Ansprüchen freizustellen, die sich aus Ihrer Nutzung der Website oder Verletzung dieser Bedingungen ergeben.',
      section14Title: '14. Anwendbares Recht und Gerichtsstand',
      section14Content: 'Diese Bedingungen unterliegen spanischem Recht. Streitigkeiten unterliegen der ausschließlichen Zuständigkeit der Gerichte von Ibiza, Spanien.',
      section15Title: '15. Änderungen der Bedingungen',
      section15Content: 'Atelier behält sich das Recht vor, diese Bedingungen jederzeit zu ändern. Die fortgesetzte Nutzung der Website gilt als Annahme der aktualisierten Bedingungen.',
      section16Title: '16. Kündigung',
      section16Content: 'Wir behalten uns das Recht vor, den Zugang zur Website nach unserem Ermessen ohne Vorankündigung bei Verstößen gegen diese Bedingungen zu beenden oder auszusetzen.',
      section17Title: '17. Salvatorische Klausel',
      section17Content: 'Sollte eine Bestimmung dieser Bedingungen für ungültig befunden werden, bleiben die übrigen Bestimmungen in vollem Umfang wirksam.',
      section18Title: '18. Kontaktinformationen',
      section18Content: 'Bei Fragen zu diesen Bedingungen:|E-Mail: Office@atelierprimeibiza.com|Adresse: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spanien'
    }
  },
  it: {
    nav: {
      home: 'Home',
      about: 'Chi Siamo',
      contact: 'Contatti'
    },
    home: {
      tagline: 'L\'arte di vivere a Ibiza',
      servicesOverline: 'La Nostra Esperienza',
      servicesTitle: 'Un Approccio Completo alla Vita di Lusso',
      servicesDescription: 'Vent\'anni di esperienza. Competenza Ibiza. Assoluta discrezione. Offriamo una suite completa di servizi su misura per una clientela esigente.',
      ibizaOverline: 'Il Nostro Focus',
      ibizaTitle: 'Esclusivamente Ibiza',
      ibizaDescription: 'Per due decenni, ci siamo dedicati alla padronanza del mercato del lusso di Ibiza. Dalle ville nascoste nel nord alle proprietà esclusive sulla spiaggia, offriamo una conoscenza impareggiabile delle proprietà più eccezionali dell\'isola.',
      ibizaDetail: 'Le nostre profonde connessioni locali, la comprensione intima del carattere dell\'isola e l\'impegno per la discrezione ci rendono la scelta fidata per clienti esigenti che cercano il meglio che Ibiza ha da offrire.',
      ctaTitle: 'Inizia il Tuo Viaggio',
      ctaDescription: 'Scopri cosa rende Atelier la scelta preferita dei clienti più esigenti in tutto il mondo',
      ctaButton: 'Contattaci'
    },
    services: {
      realEstate: {
        title: 'Vendita Immobiliare',
        description: 'Accesso esclusivo alle migliori proprietà del Mediterraneo e oltre'
      },
      rentals: {
        title: 'Affitti di Lusso',
        description: 'Ville e tenute curate per il viaggiatore esigente'
      },
      investment: {
        title: 'Consulenza Investimenti',
        description: 'Guida strategica per portafogli immobiliari di alto valore'
      },
      management: {
        title: 'Gestione Immobiliare',
        description: 'Supervisione completa delle vostre proprietà mediterranee'
      },
      development: {
        title: 'Progetti di Sviluppo',
        description: 'Opportunità di sviluppo su misura con partner verificati'
      },
      yacht: {
        title: 'Charter Yacht',
        description: 'Esperienze marittime private nel Mediterraneo'
      },
      villa: {
        title: 'Affitti Ville',
        description: 'Proprietà selezionate per soggiorni eccezionali'
      },
      aviation: {
        title: 'Aviazione Privata',
        description: 'Organizzazione viaggi aerei senza soluzione di continuità in tutto il mondo'
      },
      events: {
        title: 'Eventi Esclusivi',
        description: 'Eventi privati curati ed esperienze su misura a Ibiza'
      }
    },
    markets: {
      mediterranean: {
        name: 'Mediterraneo',
        description: 'Sede principale a Ibiza'
      },
      dubai: {
        name: 'Dubai',
        description: 'Lusso mediorientale'
      },
      miami: {
        name: 'Miami',
        description: 'Gateway americano'
      },
      newYork: {
        name: 'New York',
        description: 'Centro finanziario globale'
      }
    },
    about: {
      overline: 'Chi Siamo',
      title: 'L\'arte di vivere a Ibiza',
      intro: 'Per due decenni, Atelier ha servito come porta discreta verso le proprietà e le esperienze più eccezionali del Mediterraneo.',
      paragraph1: 'Non siamo un\'agenzia. Siamo una casa di accesso curato – dove l\'arte di vivere incontra un servizio senza compromessi. Con sede a Ibiza, con presenza a Dubai, Miami, New York e oltre, operiamo all\'intersezione tra immobiliare, investimenti e lifestyle.',
      paragraph2: 'I nostri clienti sono globali. Le loro esigenze, singolari. Rispondiamo con precisione, discrezione e una rete coltivata in vent\'anni. Nessuna transazione sotto mezzo milione di euro. Nessun compromesso sulla qualità. Nessuna eccezione alla riservatezza.',
      paragraph3: 'Dalle ville mediterranee ai charter yacht privati, dalle partnership di sviluppo ai portafogli immobiliari – facilitiamo ciò che altri non possono accedere. Questa non è abbondanza. Questa è selezione.',
      philosophyOverline: 'La Nostra Filosofia',
      philosophyTitle: 'Discrezione come Standard',
      philosophyP1: 'In Atelier, non pubblicizziamo i nostri clienti. Non pubblichiamo casi di studio. Non misuriamo il successo in volume.',
      philosophyP2: 'Quello che offriamo è questo: un approccio su misura, costruito su decenni di relazioni e conoscenza del mercato. Accesso a proprietà che non raggiungono mai le inserzioni pubbliche. Presentazioni che non si possono trovare su una piattaforma. Servizio così raffinato da diventare invisibile.',
      philosophyP3: 'La maggior parte del nostro lavoro è condotta sotto accordi di riservatezza. La nostra reputazione è costruita non sulla visibilità, ma sui risultati – e sulla fiducia di coloro che tornano da noi, anno dopo anno.',
      philosophyP4: 'Siamo Atelier. Facilitiamo l\'arte di vivere a Ibiza, e ovunque bellezza, sole e discernimento convergano.',
      stat1Label: 'Anni di Esperienza Globale',
      stat2Label: 'Transazione Minima',
      stat3Label: 'Mercati Globali',
      ctaTitle: 'Vivi la Differenza',
      ctaDescription: 'Scopri come Atelier può servire le tue esigenze immobiliari e di lifestyle',
      ctaButton: 'Contattaci'
    },
    contact: {
      overline: 'Contatti',
      title: 'Inizia una Conversazione',
      description: 'Tutte le richieste sono gestite con la massima discrezione',
      companyName: 'Atelier Prime Estates SL',
      companyTagline: 'L\'arte di vivere a Ibiza',
      addressLabel: 'Indirizzo',
      address1: 'Edificio Nueva Ibiza',
      address2: 'Carrer Gregal 8, Local 24',
      address3: '07800 Eivissa, Spagna',
      emailLabel: 'Email',
      phoneLabel: 'Telefono',
      note: 'Tutte le comunicazioni sono riservate. Rispondiamo alle richieste serie entro 24 ore.',
      formName: 'Nome',
      formEmail: 'Indirizzo Email',
      formPhone: 'Numero di Telefono',
      formMarket: 'Mercato di Interesse',
      formMarketPlaceholder: 'Seleziona un mercato',
      formMessage: 'La Tua Richiesta',
      submitButton: 'Invia Richiesta',
      submitting: 'Invio...',
      legal: 'Atelier Prime Estates SL · CIF B26974915 · Registrata in Spagna',
      marketIbiza: 'Ibiza',
      marketOther: 'Altro',
      toastTitle: 'Richiesta Ricevuta',
      toastDescription: 'Grazie per il tuo interesse. Ti contatteremo a breve.'
    },
    footer: {
      tagline: 'L\'arte di vivere a Ibiza',
      navigate: 'Naviga',
      services: 'Servizi',
      contact: 'Contatti',
      copyright: 'Atelier Prime Estates SL · CIF B26974915',
      privacy: 'Privacy Policy',
      terms: 'Termini di Servizio'
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Ultimo aggiornamento: Dicembre 2025',
      section1Title: '1. Titolare del Trattamento',
      section1Content: 'Atelier Prime Estates SL|CIF: B26974915|Indirizzo: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spagna|Email: Office@atelierprimeibiza.com',
      section2Title: '2. Dati Raccolti',
      section2Intro: 'Raccogliamo i seguenti dati personali quando utilizza i nostri servizi:',
      section2Items: 'Informazioni di Contatto: Nome, indirizzo email, numero di telefono|Dettagli Richiesta: Interessi immobiliari, preferenze di mercato, messaggi|Dati Tecnici: Indirizzo IP, tipo di browser, informazioni sul dispositivo|Cookies: Dati di utilizzo, preferenze, informazioni di sessione',
      section3Title: '3. Base Giuridica del Trattamento (LOPD/GDPR)',
      section3Intro: 'Trattiamo i tuoi dati personali sulla base di:',
      section3Items: 'Consenso: Quando invii moduli di richiesta o accetti i cookie|Necessità Contrattuale: Per fornire i servizi richiesti|Interesse Legittimo: Per migliorare i nostri servizi e comunicare opportunità rilevanti|Obbligo Legale: Per rispettare i requisiti legali spagnoli e dell\'UE',
      section4Title: '4. Come Utilizziamo i Tuoi Dati',
      section4Intro: 'Le tue informazioni personali sono utilizzate per:',
      section4Items: 'Rispondere a richieste immobiliari e di servizi|Fornire raccomandazioni immobiliari personalizzate|Inviare aggiornamenti su proprietà e servizi (con il tuo consenso)|Migliorare il nostro sito web e l\'esperienza utente|Rispettare gli obblighi legali e normativi',
      section5Title: '5. Condivisione e Divulgazione dei Dati',
      section5Intro: 'Manteniamo assoluta discrezione. I tuoi dati possono essere condivisi solo con:',
      section5Items: 'Fornitori di servizi fidati (email, hosting) sotto rigidi accordi di riservatezza|Autorità legali quando richiesto dalla legge spagnola o dell\'UE|Proprietari di immobili (solo con il tuo esplicito consenso)',
      section5Footer: 'Non vendiamo mai i tuoi dati personali a terze parti.',
      section6Title: '6. Trasferimenti Internazionali di Dati',
      section6Content: 'I tuoi dati sono principalmente archiviati all\'interno dello Spazio Economico Europeo (SEE). Eventuali trasferimenti al di fuori del SEE sono protetti da adeguate garanzie in conformità con l\'articolo 46 del GDPR.',
      section7Title: '7. I Tuoi Diritti ai Sensi del LOPD/GDPR',
      section7Intro: 'Hai il diritto di:',
      section7Items: 'Accesso: Richiedere una copia dei tuoi dati personali|Rettifica: Correggere informazioni inesatte|Cancellazione: Richiedere la cancellazione dei tuoi dati ("diritto all\'oblio")|Limitazione: Limitare il modo in cui trattiamo i tuoi dati|Portabilità: Ricevere i tuoi dati in un formato strutturato|Opposizione: Opporsi al trattamento basato su interessi legittimi|Revoca del Consenso: Revocare il consenso in qualsiasi momento',
      section7Footer: 'Per esercitare questi diritti, contattaci a Office@atelierprimeibiza.com',
      section8Title: '8. Conservazione dei Dati',
      section8Content: 'Conserviamo i tuoi dati personali solo per il tempo necessario a soddisfare gli scopi delineati in questa policy o come richiesto dalla legge spagnola. I dati delle richieste dei clienti sono tipicamente conservati per 3 anni, salvo richiesta di cancellazione anticipata.',
      section9Title: '9. Misure di Sicurezza',
      section9Content: 'Implementiamo misure di sicurezza standard del settore tra cui crittografia, server sicuri e controlli di accesso per proteggere i tuoi dati personali da accesso non autorizzato, alterazione o divulgazione.',
      section10Title: '10. Cookies',
      section10Content: 'Utilizziamo i cookie per migliorare la tua esperienza di navigazione. Puoi gestire le preferenze dei cookie tramite il nostro banner dei cookie. Per i dettagli, consulta la nostra Cookie Policy.',
      section11Title: '11. Privacy dei Minori',
      section11Content: 'I nostri servizi non sono rivolti a persone di età inferiore a 18 anni. Non raccogliamo consapevolmente dati da minori.',
      section12Title: '12. Modifiche a Questa Policy',
      section12Content: 'Potremmo aggiornare periodicamente questa Privacy Policy. Le modifiche saranno pubblicate su questa pagina con una data di revisione aggiornata.',
      section13Title: '13. Contatti e Reclami',
      section13Content: 'Per problemi di privacy o per presentare un reclamo:|Email: Office@atelierprimeibiza.com|Indirizzo: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spagna',
      section13Footer: 'Hai anche il diritto di presentare un reclamo all\'Autorità Spagnola per la Protezione dei Dati (Agencia Española de Protección de Datos - AEPD).'
    },
    terms: {
      title: 'Termini di Servizio',
      lastUpdated: 'Ultimo aggiornamento: Dicembre 2025',
      section1Title: '1. Accettazione dei Termini',
      section1Content: 'Accedendo e utilizzando il sito web di Atelier Prime Estates SL ("Sito Web"), accetti di essere vincolato da questi Termini di Servizio. Se non sei d\'accordo, interrompi immediatamente l\'uso.',
      section2Title: '2. Informazioni sulla Società',
      section2Content: 'Atelier Prime Estates SL|CIF: B26974915|Indirizzo Registrato: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spagna|Registrata in Spagna',
      section3Title: '3. Servizi Forniti',
      section3Intro: 'Atelier offre servizi immobiliari e di lifestyle di lusso tra cui:',
      section3Items: 'Vendita e affitto immobiliare|Consulenza sugli investimenti|Gestione immobiliare|Progetti di sviluppo|Servizi lifestyle di lusso (charter yacht, affitti ville, aviazione privata)',
      section3Footer: 'Tutti i servizi sono soggetti ad accordi individuali e non sono garantiti solo attraverso l\'uso del Sito Web.',
      section4Title: '4. Idoneità',
      section4Content: 'I nostri servizi sono destinati a persone di età pari o superiore a 18 anni. Utilizzando questo Sito Web, dichiari di soddisfare questo requisito di età.',
      section5Title: '5. Requisiti Minimi di Transazione',
      section5Content: 'Atelier è specializzata in transazioni di alto valore con una soglia minima di €500.000. Ci riserviamo il diritto di rifiutare richieste che non soddisfano i nostri criteri di servizio.',
      section6Title: '6. Riservatezza e Non Divulgazione',
      section6Content: 'Tutte le interazioni con i clienti sono condotte con assoluta discrezione. I dettagli delle proprietà, le informazioni sui clienti e i termini delle transazioni sono riservati. La maggior parte dei servizi è fornita sotto accordi di non divulgazione (NDA).',
      section7Title: '7. Proprietà Intellettuale',
      section7Content: 'Tutti i contenuti di questo Sito Web, inclusi testo, immagini, loghi e design, sono di proprietà di Atelier Prime Estates SL e protetti dalle leggi spagnole e internazionali sul copyright. L\'uso non autorizzato è vietato.',
      section8Title: '8. Restrizioni sull\'Uso del Sito Web',
      section8Intro: 'Accetti di non:',
      section8Items: 'Utilizzare il Sito Web per scopi illeciti|Tentare di ottenere accesso non autorizzato ai nostri sistemi|Interferire con la funzionalità del Sito Web|Copiare, riprodurre o distribuire contenuti del Sito Web senza autorizzazione|Utilizzare sistemi automatizzati per raschiare o estrarre dati',
      section9Title: '9. Annunci e Informazioni sulle Proprietà',
      section9Content: 'Le informazioni sulle proprietà sono fornite a titolo di riferimento generale. Dettagli, disponibilità e prezzi sono soggetti a modifiche senza preavviso. Atelier non fornisce garanzie riguardo all\'accuratezza o completezza delle informazioni sugli annunci.',
      section10Title: '10. Link di Terze Parti',
      section10Content: 'Il nostro Sito Web può contenere link a siti di terze parti. Atelier non è responsabile per il contenuto o le pratiche di siti web esterni.',
      section11Title: '11. Limitazione di Responsabilità',
      section11Content: 'Nella misura massima consentita dalla legge spagnola, Atelier Prime Estates SL non sarà responsabile per danni indiretti, incidentali o consequenziali derivanti dall\'uso del Sito Web o dalla fornitura di servizi.',
      section12Title: '12. Esclusione di Garanzie',
      section12Content: 'Il Sito Web è fornito "così com\'è" senza garanzie di alcun tipo. Atelier non garantisce un funzionamento ininterrotto o privo di errori.',
      section13Title: '13. Indennizzo',
      section13Content: 'Accetti di indennizzare Atelier Prime Estates SL da rivendicazioni derivanti dal tuo uso del Sito Web o dalla violazione di questi Termini.',
      section14Title: '14. Legge Applicabile e Giurisdizione',
      section14Content: 'Questi Termini sono regolati dalla legge spagnola. Eventuali controversie saranno soggette alla giurisdizione esclusiva dei tribunali di Ibiza, Spagna.',
      section15Title: '15. Modifiche ai Termini',
      section15Content: 'Atelier si riserva il diritto di modificare questi Termini in qualsiasi momento. L\'uso continuato del Sito Web costituisce accettazione dei Termini aggiornati.',
      section16Title: '16. Risoluzione',
      section16Content: 'Ci riserviamo il diritto di terminare o sospendere l\'accesso al Sito Web a nostra discrezione, senza preavviso, per violazioni di questi Termini.',
      section17Title: '17. Clausola di Salvaguardia',
      section17Content: 'Se una qualsiasi disposizione di questi Termini viene ritenuta non valida, le disposizioni rimanenti continueranno ad avere pieno effetto.',
      section18Title: '18. Informazioni di Contatto',
      section18Content: 'Per domande riguardanti questi Termini:|Email: Office@atelierprimeibiza.com|Indirizzo: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, Spagna'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Nosotros',
      contact: 'Contacto'
    },
    home: {
      tagline: 'El arte de vivir en Ibiza',
      servicesOverline: 'Nuestra Experiencia',
      servicesTitle: 'Un Enfoque Integral para la Vida de Lujo',
      servicesDescription: 'Veinte años de experiencia. Experiencia en Ibiza. Discreción absoluta. Ofrecemos un conjunto completo de servicios adaptados a las necesidades de una clientela exigente.',
      ibizaOverline: 'Nuestro Enfoque',
      ibizaTitle: 'Exclusivamente Ibiza',
      ibizaDescription: 'Durante dos décadas, nos hemos dedicado a dominar el mercado de lujo de Ibiza. Desde villas escondidas en el norte hasta propiedades exclusivas frente al mar, ofrecemos un conocimiento incomparable de las propiedades más excepcionales de la isla.',
      ibizaDetail: 'Nuestras profundas conexiones locales, comprensión íntima del carácter de la isla y compromiso con la discreción nos convierten en la elección de confianza para clientes exigentes que buscan lo mejor que Ibiza tiene para ofrecer.',
      ctaTitle: 'Comience Su Viaje',
      ctaDescription: 'Descubra qué hace de Atelier la opción preferida de clientes exigentes en todo el mundo',
      ctaButton: 'Póngase en Contacto'
    },
    services: {
      realEstate: {
        title: 'Venta de Inmuebles',
        description: 'Acceso exclusivo a las mejores propiedades del Mediterráneo y más allá'
      },
      rentals: {
        title: 'Alquileres de Lujo',
        description: 'Villas y fincas seleccionadas para el viajero exigente'
      },
      investment: {
        title: 'Asesoría de Inversiones',
        description: 'Orientación estratégica para carteras inmobiliarias de alto valor'
      },
      management: {
        title: 'Gestión de Propiedades',
        description: 'Supervisión integral de sus propiedades mediterráneas'
      },
      development: {
        title: 'Proyectos de Desarrollo',
        description: 'Oportunidades de desarrollo a medida con socios verificados'
      },
      yacht: {
        title: 'Chárter de Yates',
        description: 'Experiencias marítimas privadas en el Mediterráneo'
      },
      villa: {
        title: 'Alquiler de Villas',
        description: 'Propiedades seleccionadas para estancias excepcionales'
      },
      aviation: {
        title: 'Aviación Privada',
        description: 'Arreglos de viajes aéreos sin fisuras en todo el mundo'
      },
      events: {
        title: 'Eventos Exclusivos',
        description: 'Eventos privados seleccionados y experiencias a medida en Ibiza'
      }
    },
    markets: {
      mediterranean: {
        name: 'Mediterráneo',
        description: 'Base principal en Ibiza'
      },
      dubai: {
        name: 'Dubái',
        description: 'Lujo de Oriente Medio'
      },
      miami: {
        name: 'Miami',
        description: 'Puerta americana'
      },
      newYork: {
        name: 'Nueva York',
        description: 'Centro financiero global'
      }
    },
    about: {
      overline: 'Sobre Atelier',
      title: 'El arte de vivir en Ibiza',
      intro: 'Durante dos décadas, Atelier ha servido como la puerta silenciosa a las propiedades y experiencias más excepcionales del Mediterráneo.',
      paragraph1: 'No somos una agencia. Somos una casa de acceso curado – donde el arte de vivir se encuentra con un servicio sin concesiones. Con sede en Ibiza, con presencia en Dubái, Miami, Nueva York y más allá, operamos en la intersección de bienes raíces, inversión y estilo de vida.',
      paragraph2: 'Nuestros clientes son globales. Sus necesidades, singulares. Respondemos con precisión, discreción y una red cultivada durante veinte años. Sin transacciones por debajo de medio millón de euros. Sin concesiones en calidad. Sin excepciones a la confidencialidad.',
      paragraph3: 'Desde villas mediterráneas hasta chárteres de yates privados, desde asociaciones de desarrollo hasta carteras inmobiliarias – facilitamos lo que otros no pueden acceder. Esto no es abundancia. Esto es selección.',
      philosophyOverline: 'Nuestra Filosofía',
      philosophyTitle: 'Discreción como Estándar',
      philosophyP1: 'En Atelier, no anunciamos a nuestros clientes. No publicamos estudios de casos. No medimos el éxito en volumen.',
      philosophyP2: 'Lo que ofrecemos es esto: un enfoque a medida, construido sobre décadas de relaciones y conocimiento del mercado. Acceso a propiedades que nunca llegan a listados públicos. Presentaciones que no se pueden encontrar en una plataforma. Servicio tan refinado que se vuelve invisible.',
      philosophyP3: 'La mayor parte de nuestro trabajo se realiza bajo acuerdos de confidencialidad. Nuestra reputación no se basa en la visibilidad, sino en los resultados – y la confianza de aquellos que regresan a nosotros, año tras año.',
      philosophyP4: 'Somos Atelier. Facilitamos el arte de vivir en Ibiza, y donde sea que la belleza, el sol y el discernimiento converjan.',
      stat1Label: 'Años de Experiencia Global',
      stat2Label: 'Transacción Mínima',
      stat3Label: 'Mercados Globales',
      ctaTitle: 'Experimente la Diferencia',
      ctaDescription: 'Descubra cómo Atelier puede atender sus necesidades inmobiliarias y de estilo de vida',
      ctaButton: 'Contáctenos'
    },
    contact: {
      overline: 'Contacto',
      title: 'Inicie una Conversación',
      description: 'Todas las consultas se manejan con la máxima discreción',
      companyName: 'Atelier Prime Estates SL',
      companyTagline: 'El arte de vivir en Ibiza',
      addressLabel: 'Dirección',
      address1: 'Edificio Nueva Ibiza',
      address2: 'Carrer Gregal 8, Local 24',
      address3: '07800 Eivissa, España',
      emailLabel: 'Correo',
      phoneLabel: 'Teléfono',
      note: 'Todas las comunicaciones son confidenciales. Respondemos a consultas serias en 24 horas.',
      formName: 'Nombre',
      formEmail: 'Dirección de Correo',
      formPhone: 'Número de Teléfono',
      formMarket: 'Mercado de Interés',
      formMarketPlaceholder: 'Seleccione un mercado',
      formMessage: 'Su Consulta',
      submitButton: 'Enviar Consulta',
      submitting: 'Enviando...',
      legal: 'Atelier Prime Estates SL · CIF B26974915 · Registrada en España',
      marketIbiza: 'Ibiza',
      marketOther: 'Otro',
      toastTitle: 'Consulta Recibida',
      toastDescription: 'Gracias por su interés. Nos pondremos en contacto en breve.'
    },
    footer: {
      tagline: 'El arte de vivir en Ibiza',
      navigate: 'Navegar',
      services: 'Servicios',
      contact: 'Contacto',
      copyright: 'Atelier Prime Estates SL · CIF B26974915',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio'
    },
    privacy: {
      title: 'Política de Privacidad',
      lastUpdated: 'Última actualización: Diciembre 2025',
      section1Title: '1. Responsable del Tratamiento',
      section1Content: 'Atelier Prime Estates SL|CIF: B26974915|Dirección: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, España|Email: Office@atelierprimeibiza.com',
      section2Title: '2. Datos que Recopilamos',
      section2Intro: 'Recopilamos los siguientes datos personales cuando utiliza nuestros servicios:',
      section2Items: 'Información de Contacto: Nombre, dirección de correo electrónico, número de teléfono|Detalles de Consulta: Intereses inmobiliarios, preferencias de mercado, mensajes|Datos Técnicos: Dirección IP, tipo de navegador, información del dispositivo|Cookies: Datos de uso, preferencias, información de sesión',
      section3Title: '3. Base Legal para el Tratamiento (LOPD/RGPD)',
      section3Intro: 'Procesamos sus datos personales sobre la base de:',
      section3Items: 'Consentimiento: Cuando envía formularios de consulta o acepta cookies|Necesidad Contractual: Para proporcionar los servicios que solicita|Interés Legítimo: Para mejorar nuestros servicios y comunicar oportunidades relevantes|Obligación Legal: Para cumplir con los requisitos legales españoles y de la UE',
      section4Title: '4. Cómo Utilizamos Sus Datos',
      section4Intro: 'Su información personal se utiliza para:',
      section4Items: 'Responder a consultas inmobiliarias y solicitudes de servicios|Proporcionar recomendaciones inmobiliarias personalizadas|Enviar actualizaciones sobre propiedades y servicios (con su consentimiento)|Mejorar nuestro sitio web y experiencia del usuario|Cumplir con obligaciones legales y regulatorias',
      section5Title: '5. Compartir y Divulgación de Datos',
      section5Intro: 'Mantenemos absoluta discreción. Sus datos solo pueden compartirse con:',
      section5Items: 'Proveedores de servicios de confianza (email, hosting) bajo estrictos acuerdos de confidencialidad|Autoridades legales cuando lo requiera la ley española o de la UE|Propietarios de inmuebles (solo con su consentimiento explícito)',
      section5Footer: 'Nunca vendemos sus datos personales a terceros.',
      section6Title: '6. Transferencias Internacionales de Datos',
      section6Content: 'Sus datos se almacenan principalmente dentro del Espacio Económico Europeo (EEE). Cualquier transferencia fuera del EEE está protegida por garantías apropiadas de conformidad con el Artículo 46 del RGPD.',
      section7Title: '7. Sus Derechos Bajo LOPD/RGPD',
      section7Intro: 'Usted tiene derecho a:',
      section7Items: 'Acceso: Solicitar una copia de sus datos personales|Rectificación: Corregir información inexacta|Supresión: Solicitar la eliminación de sus datos ("derecho al olvido")|Limitación: Limitar cómo procesamos sus datos|Portabilidad: Recibir sus datos en un formato estructurado|Oposición: Oponerse al procesamiento basado en intereses legítimos|Retirar el Consentimiento: Revocar el consentimiento en cualquier momento',
      section7Footer: 'Para ejercer estos derechos, contáctenos en Office@atelierprimeibiza.com',
      section8Title: '8. Conservación de Datos',
      section8Content: 'Conservamos sus datos personales solo durante el tiempo necesario para cumplir los propósitos descritos en esta política o según lo requiera la ley española. Los datos de consultas de clientes generalmente se conservan durante 3 años, a menos que solicite su eliminación anticipada.',
      section9Title: '9. Medidas de Seguridad',
      section9Content: 'Implementamos medidas de seguridad estándar de la industria, incluyendo cifrado, servidores seguros y controles de acceso para proteger sus datos personales del acceso, alteración o divulgación no autorizados.',
      section10Title: '10. Cookies',
      section10Content: 'Utilizamos cookies para mejorar su experiencia de navegación. Puede gestionar las preferencias de cookies a través de nuestro banner de cookies. Para más detalles, consulte nuestra Política de Cookies.',
      section11Title: '11. Privacidad de Menores',
      section11Content: 'Nuestros servicios no están dirigidos a personas menores de 18 años. No recopilamos conscientemente datos de menores.',
      section12Title: '12. Cambios en Esta Política',
      section12Content: 'Podemos actualizar esta Política de Privacidad periódicamente. Los cambios se publicarán en esta página con una fecha de revisión actualizada.',
      section13Title: '13. Contacto y Reclamaciones',
      section13Content: 'Para consultas sobre privacidad o para presentar una queja:|Email: Office@atelierprimeibiza.com|Dirección: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, España',
      section13Footer: 'También tiene derecho a presentar una queja ante la Agencia Española de Protección de Datos (AEPD).'
    },
    terms: {
      title: 'Términos de Servicio',
      lastUpdated: 'Última actualización: Diciembre 2025',
      section1Title: '1. Aceptación de los Términos',
      section1Content: 'Al acceder y utilizar el sitio web de Atelier Prime Estates SL ("Sitio Web"), usted acepta estar sujeto a estos Términos de Servicio. Si no está de acuerdo, discontinúe el uso inmediatamente.',
      section2Title: '2. Información de la Empresa',
      section2Content: 'Atelier Prime Estates SL|CIF: B26974915|Dirección Registrada: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, España|Registrada en España',
      section3Title: '3. Servicios Proporcionados',
      section3Intro: 'Atelier ofrece servicios inmobiliarios y de estilo de vida de lujo que incluyen:',
      section3Items: 'Ventas y alquileres inmobiliarios|Asesoría de inversiones|Gestión de propiedades|Proyectos de desarrollo|Servicios de lifestyle de lujo (chárter de yates, alquiler de villas, aviación privada)',
      section3Footer: 'Todos los servicios están sujetos a acuerdos individuales y no están garantizados solo mediante el uso del Sitio Web.',
      section4Title: '4. Elegibilidad',
      section4Content: 'Nuestros servicios están destinados a personas mayores de 18 años. Al utilizar este Sitio Web, usted declara que cumple con este requisito de edad.',
      section5Title: '5. Requisitos Mínimos de Transacción',
      section5Content: 'Atelier se especializa en transacciones de alto valor con un umbral mínimo de €500,000. Nos reservamos el derecho de rechazar consultas que no cumplan con nuestros criterios de servicio.',
      section6Title: '6. Confidencialidad y No Divulgación',
      section6Content: 'Todas las interacciones con clientes se realizan con absoluta discreción. Los detalles de las propiedades, información del cliente y términos de transacción son confidenciales. La mayoría de los servicios se proporcionan bajo acuerdos de no divulgación (NDA).',
      section7Title: '7. Propiedad Intelectual',
      section7Content: 'Todo el contenido de este Sitio Web, incluidos texto, imágenes, logotipos y diseño, es propiedad de Atelier Prime Estates SL y está protegido por las leyes de derechos de autor españolas e internacionales. El uso no autorizado está prohibido.',
      section8Title: '8. Restricciones de Uso del Sitio Web',
      section8Intro: 'Usted acepta no:',
      section8Items: 'Utilizar el Sitio Web para fines ilícitos|Intentar obtener acceso no autorizado a nuestros sistemas|Interferir con la funcionalidad del Sitio Web|Copiar, reproducir o distribuir contenido del Sitio Web sin permiso|Utilizar sistemas automatizados para extraer o copiar datos',
      section9Title: '9. Listados e Información de Propiedades',
      section9Content: 'La información de propiedades se proporciona como referencia general. Los detalles, disponibilidad y precios están sujetos a cambios sin previo aviso. Atelier no ofrece garantías sobre la precisión o integridad de la información de listados.',
      section10Title: '10. Enlaces de Terceros',
      section10Content: 'Nuestro Sitio Web puede contener enlaces a sitios de terceros. Atelier no es responsable del contenido o prácticas de sitios web externos.',
      section11Title: '11. Limitación de Responsabilidad',
      section11Content: 'En la máxima medida permitida por la ley española, Atelier Prime Estates SL no será responsable de daños indirectos, incidentales o consecuentes derivados del uso del Sitio Web o la prestación de servicios.',
      section12Title: '12. Renuncia de Garantías',
      section12Content: 'El Sitio Web se proporciona "tal cual" sin garantías de ningún tipo. Atelier no garantiza un funcionamiento ininterrumpido o libre de errores.',
      section13Title: '13. Indemnización',
      section13Content: 'Usted acepta indemnizar a Atelier Prime Estates SL de reclamos que surjan de su uso del Sitio Web o violación de estos Términos.',
      section14Title: '14. Ley Aplicable y Jurisdicción',
      section14Content: 'Estos Términos se rigen por la ley española. Cualquier disputa estará sujeta a la jurisdicción exclusiva de los tribunales de Ibiza, España.',
      section15Title: '15. Modificaciones de los Términos',
      section15Content: 'Atelier se reserva el derecho de modificar estos Términos en cualquier momento. El uso continuado del Sitio Web constituye la aceptación de los Términos actualizados.',
      section16Title: '16. Terminación',
      section16Content: 'Nos reservamos el derecho de terminar o suspender el acceso al Sitio Web a nuestra discreción, sin previo aviso, por violaciones de estos Términos.',
      section17Title: '17. Divisibilidad',
      section17Content: 'Si alguna disposición de estos Términos se considera inválida, las disposiciones restantes continuarán en pleno efecto.',
      section18Title: '18. Información de Contacto',
      section18Content: 'Para preguntas sobre estos Términos:|Email: Office@atelierprimeibiza.com|Dirección: Edificio Nueva Ibiza, Carrer Gregal 8, Local 24, 07800 Eivissa, España'
    }
  }
};
